import ReactSlider from 'react-slider'
import styled, { keyframes } from 'styled-components'
import { useEffect, useState, useRef } from 'react'
import { BsArrowsExpandVertical } from 'react-icons/bs'

interface AnswerProps {
  min: number
  max: number
  step: number
  defaultValue: number
  onChange: (value: number) => void
}

const Slider = ({ min, max, step, defaultValue, onChange }: AnswerProps) => {
  const [value, setValue] = useState<number>(defaultValue)
  const userInteracted = useRef<boolean>(false)

  useEffect(() => {
    if (!userInteracted.current && value !== defaultValue) {
      userInteracted.current = true
    }
    onChange(value)
  }, [value, onChange])

  return (
    <Container>
      <StyledSlider
        min={min}
        max={max}
        step={step}
        defaultValue={defaultValue}
        renderTrack={Track}
        renderThumb={(props, state) => (
          <ThumbContainer {...props}>
            {!userInteracted.current && <Pulse />}
            <StyledThumb>
              <BsArrowsExpandVertical />
            </StyledThumb>
          </ThumbContainer>
        )}
        value={value}
        onChange={(value) => {
          if (typeof value === 'number') {
            setValue(value)
          }
        }}
      />
      {!userInteracted.current && (
        <Hint>
          Changez les années{' '}
          <Svg width={55} height={55}>
            <defs>
              <marker
                id='head'
                orient='auto'
                markerWidth='50'
                markerHeight='50'
                refX='5'
                refY='5'
              >
                <path d='M0,0 L5,5 L0,10' fill='none' stroke='#222426' />
              </marker>
            </defs>
            <Line
              markerEnd='url(#head)'
              d={`M ${30} ${30} Q ${25} ${10} ${5} ${5}`}
            />
          </Svg>
        </Hint>
      )}
    </Container>
  )
}

const Hint = styled.div`
  position: absolute;
  bottom: -30px;
  left: 50%;
  font-size: 0.75em;
`

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 0;
  }
  70% {
    transform: scale(1.5);
    opacity: 0.15;
  }
  100% {
    transform: scale(1.85);
    opacity: 0;
  }
`

const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 50px;
  background: ${({ theme }) => theme.greyLight};
  border-radius: 999px;
  box-shadow: ${({ theme }) => theme.colorMode === 'light' ? 'inset rgba(0, 0, 0, 0.1) 0px 0px 10px 0px' : 'inset rgba(0, 0, 0, 0.5) 0px 0px 10px 0px'};
`

const Svg = styled.svg`
  position: absolute;
  top: 0;
  left: -20px;
  transform: translate(100%, -50%);
`

const Line = styled.path`
  stroke: #222426;
  stroke-width: 1px;
  fill: none;
`

const ThumbContainer = styled.div`
  height: 40px;
  width: 40px;
  color: var(--brandblue-main);
  border-radius: 50%;
  cursor: grab;
  margin-top: 5px;
  outline: none;
`

const StyledThumb = styled.div`
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);
  background: ${({ theme }) => `rgb(${theme.mainColor})`};
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ffffff66;
  box-sizing: border-box;
  outline: none;
`

const Pulse = styled.div`
  position: absolute;
  z-index: -1;
  background: ${({ theme }) => `rgb(${theme.mainColor})`};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${pulse} 2s infinite;
  // transform-origin: center;
`

const StyledTrack = styled.div`
  top: 0;
  bottom: 0;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

const Track = (props: any, state: any) => (
  <StyledTrack {...props} index={state.index} />
)

export default Slider
